<div class="d-flex justify-content-center mt-4">

    <div class="row">
        <div class="col-md-4">
            <label for="idGlobalCustomer">LO Global Customer Id *</label>
            <input type="text" [disabled]="isModifica" [(ngModel)]="idGlobalCustomer"
                [ngClass]="{'input-error': !idGlobalCustomer}" class="form-control" id="idGlobalCustomer"
                name="idGlobalCustomer" placeholder="IdGlobalCustomer">
        </div>
        <div class="col-md-4">
            <label for="globalCustomerName" style="white-space: nowrap ;">Global Customer Name *</label>
            <input type="text" [(ngModel)]="globalCustomerName" [ngClass]="{'input-error': !globalCustomerName}"
                class="form-control" id="globalCustomerName" name="globalCustomerName" placeholder="GlobalCustomerName">
        </div>
        <div class="col-md-4">
            <label for="operator">Lead Operator *</label>
            <select [(ngModel)]="operator" class="form-select" [ngClass]="{'input-error': !operator}" id="operator"
                name="operator">
                <option value="IMSA">DEUTSCHE TELEKOM</option>
                <option value="TELIA">TELIA</option>
                <option value="ORANGE">ORANGE</option>
                <option value="TIM">TIM</option>
                <option value="FREEMOVE">FREEMOVE</option>
            </select>
        </div>
    </div>
    
</div>
<div class="row mt-2">
    <div class="col-md-12">
        <label for="note">Note</label>
        <textarea class="form-control" id="note" rows="2" [(ngModel)]="note"></textarea>
    </div>
</div>

<div class="d-flex justify-content-center mt-4">
    <div class="row">
        <span class="span-error" *ngIf="customerDataLeadOperatorFormDisabled()">Fill in all mandatory fields marked with
            * to go next step</span>
    </div>
</div>


<div class="d-flex justify-content-end mt-4">
    <button class="btn btn-primary btn-lg active btn-sm" [disabled]="customerDataLeadOperatorFormDisabled()"
        (click)="goToCustomerDataBOperator()" #goToStepBOperator>Next</button>
    <button class="btn btn-primary btn-lg active button-reset btn-sm" [disabled]="formDisable()"
        (click)="resetForm()">Reset</button>
</div>